import type { SupabaseClient } from '@supabase/supabase-js'
import { Database } from 'supabase/database.types'

import { queryKeys } from './queryKeys'

/** Shared with useQuery in apiOrgUsers and ensureQueryData in authProvider. */
export const ORG_USER_QUERY_STALE_MS = 60_000

export const orgUserQueryKey = (userId: string) =>
  [queryKeys.org_user, userId] as const

export async function fetchOrgUserRow(
  supabase: SupabaseClient<Database>,
  userId: string
) {
  const res = await supabase
    .from('org_user')
    .select(`*, user!org_user_user_id_fkey(*), role(*), organization(*)`)
    .eq('user_id', userId)
    .limit(1)

  return {
    ...res,
    data: Array.isArray(res.data) ? res.data[0] ?? null : res.data,
  }
}
